import { parseDay } from "./format"

const pad = n => String(n).padStart(2, "0")

export const iso = date => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`

export const addDays = (value, days) => {
  const date = parseDay(value)
  date.setDate(date.getDate() + days)
  return iso(date)
}

export const startOfWeek = value => {
  const date = parseDay(value)
  const shift = (date.getDay() + 6) % 7
  date.setDate(date.getDate() - shift)
  return iso(date)
}

export const startOfMonth = value => {
  const date = parseDay(value)
  return iso(new Date(date.getFullYear(), date.getMonth(), 1))
}

export const endOfMonth = value => {
  const date = parseDay(value)
  return iso(new Date(date.getFullYear(), date.getMonth() + 1, 0))
}

export const addMonths = (value, months) => {
  const date = parseDay(value)
  return iso(new Date(date.getFullYear(), date.getMonth() + months, 1))
}

export const today = () => iso(new Date())

export const rangeFor = (mode, anchor) => {
  if (mode === "month") return { from: startOfMonth(anchor), to: endOfMonth(anchor) }
  const from = startOfWeek(anchor)
  return { from, to: addDays(from, 6) }
}

export const shiftRange = (mode, from, step) => {
  if (mode === "month") return rangeFor("month", addMonths(from, step))
  return rangeFor("week", addDays(from, 7 * step))
}

export const spanHours = (start, end, breakMinutes) => {
  if (!start || !end) return null
  const [h1, m1] = start.split(":").map(Number)
  const [h2, m2] = end.split(":").map(Number)
  // An end before the start is the next morning: a night shift.
  const minutes = ((h2 * 60 + m2 - (h1 * 60 + m1) + 1440) % 1440) - (Number(breakMinutes) || 0)
  if (Number.isNaN(minutes)) return null
  return Math.max(0, minutes) / 60
}
